<template>
  <div class="sun not-full SectionBenefit">
    <div class="list slow delay-500ms" v-inview:animate="'fadeIn'">
      <div class="item" >
        <div class="title">
          대출 종류
        </div>
        <div class="line">
          <div></div>
        </div>
        <div class="content">
          <div class="top">
            펀다x중소벤처기업부 제공 (이자액 환급 대출)
          </div>
          <div class="bottom">
            <b>중금리 무이자 대출</b>
          </div>
        </div>
      </div>

      <div class="item slow delay-500ms" v-inview:animate="'fadeIn'">
        <div class="title">
          최대 한도
        </div>
        <div class="line">
          <div></div>
        </div>
        <div class="content">
          <div class="top">
            <b>2,000만원</b>
          </div>
          <div class="bottom">
            평균 1,000만원 대출 가능
          </div>
        </div>
      </div>

      <div class="item slow delay-500ms" v-inview:animate="'fadeIn'">
        <div class="title">
          이자액
        </div>
        <div class="line">
          <div></div>
        </div>
        <div class="content">
          <div class="top">
            <span>1,000만원 대출 시,</span> <b>22~27만원</b>
          </div>
          <div class="bottom">
            계약 금리 연 11%, 실질 부담 이율 2.2~2.7%
          </div>
        </div>
      </div>
    </div>

    <div class="guide slow delay-500ms" v-inview:animate="'fadeIn'">
      <p>아래 카카오로그인 후에<br />빠르게 신청하실 수 있습니다!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionBenefit',
  components: {
  },
  props: {},
  data: function () {
    return {
    }
  },
  computed: {
  },
  async created() {
  },
  destroyed() {},
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .SectionBenefit {
    padding-top: 50px;
    padding-bottom: 50px;
    float: left;

    .guide {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #333;
      margin-top: 26px;
      font-weight: 900;
      p {
        width: 100%;
        text-align: center;
        line-height: 1.5;
      }
    }

    .list {
      .item {
        width: 100%;
        height: 100px;
        border-radius: 8px;
        background-color: #ffffff;
        display: flex !important;
        box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
        transform: translateY(0px);

        &:hover {
          transition: all 1s;
          box-shadow: 8px 12px 24px 0 rgba(0, 0, 0, 0.24);
          transform: translateY(-6px);
        }

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        .title {
          width: calc(102% / 325 * 100);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 16px;
          line-height: 1.56;
          letter-spacing: -0.2px;
          color: #8a94a2;
        }

        .line {
          display: flex;
          align-items: center;
          justify-content: center;
          div {
            width: 1px;
            height: 42px;
            background-color: #d7e1ea;
          }
        }

        .content {
          width: calc(223% / 325 * 100 - 1px);
          padding-left: 17px;
          padding-right: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 13px;
          .top {
            width: 100%;
            line-height: 1.6;
            word-wrap: break-word;
            b {
              font-weight: 800;
              font-size: 20px;
              line-height: 0.73;
              letter-spacing: -0.41px;
              color: #333333;
              word-break: keep-all;
            }
          }
          .bottom {
            width: 100%;
            margin-top: 2px;
            b {
              font-weight: 800;
              font-size: 20px;
              line-height: 1.17;
              letter-spacing: -0.3px;
              color: #333333;
            }
          }
        }

      }
    }
  }
</style>
